export default {"src":"/_next/static/media/propertyDamage_64.d335837b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};